<template>
  <div class="shopdetail">
    <div class="search1">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <template v-for="(item, index) in form.gallery">
          <van-swipe-item :key="index">
            <img style="width:100%;" :src="item" />
          </van-swipe-item>
        </template>
      </van-swipe>
    </div>
    <div class="txt">
      <p>{{ form.proName }}</p>
      <p class="price">¥{{ form.price }}</p>
    </div>
    <div class="contentdiv">
      <p>商品规格</p>
      <section class="group" v-if="$properties(form.channel, 'value')=='shop'">{{ $properties(form.shopSpecs, 'label') }}</section>
      <section class="group" v-else-if="$properties(form.channel, 'value')=='rented'">{{ $properties(form.rentedSpecs, 'label') }}</section>
      <div class="clear"></div>
    </div>
    <div class="txt line">
      <p class="txt1">产品明细</p>
      <p class="text1" v-html="form.proDetail">
        <!-- 生命种子*3；孕育之盆*3；心灵卡片*15；祭思笔*1；金锡祈福*1 -->
        <!-- {{ form.proDetail }} -->
      </p>
    </div>
    <div class="txt line">
      <p class="txt1">性能和特点</p>
      <p class="text1" v-html="form.proFeature">
        <!-- 本套装主要用于殡葬、祭祀的追思环节，让缅怀更具仪式感。本产品无毒无害，符合环评标准，可放心使用。 -->
        <!-- {{ form.proFeature }} -->
      </p>
    </div>
    <div class="txt line">
      <p class="txt1">注意事项</p>
      <p class="text1" v-html="form.proNotice">
        <!-- 1、部份产品可更具需要分次使用。2、请放置在阴凉通风处，避免阳光直晒。3、不要放置在儿童可以拿到的地方，以免误食危险情况发生。4、生命种子播种后浇水不可太多，避免种子腐烂。 -->
        <!-- {{ form.proNotice }} -->
      </p>
    </div>
    <section class="footdiv">
      <template v-if="$properties(form.channel,'value')=='shop'">
        <a href="/shop/cart?channel=shop" class="cart">
          <i class="iconfont icon">&#xe70b;</i>

          <div class="nn">{{ $store.getters.mycart.length }}</div>
        </a>
        <span class="fav">
          <i
            v-if="$store.getters.mycollect.indexOf(id) > -1"
            class="iconfont"
            style="color:#dea767;"
            @click="cancelCollect(id)"
            >&#xe627;</i
          >
          <i v-else class="iconfont" @click="addCollect(id)">&#xe627;</i>
        </span>
        <p></p>

        <a v-if="$store.getters.mycart.indexOf(id) > -1" class="addcart" @click="cancelCart(id)"
          >移除购物车</a
        >
      <a v-else class="addcart" @click="addCart(id)">加入购物车</a>
      </template>
      <a class="goto" href="javascript:void(0)" @click="goPay()">立即购买</a>
    </section>
    <div class="clear-both"></div>
  </div>
</template>

<script>
export default {
  name: 'shopdetail',
  data() {
    return {
      form: {
        id: 0,
        proName: '',
        channel: {},
        shopSpecs: {},
        rentedSpecs: {},
        gallery: [],
        price: 0,
        proDetail: '',
        proNotice: '',
        proFeature: '',
      },
    }
  },
  created() {
    var params = this.$route.params
    this.queryGoodsOne(params['id'])
    this.id = params['id']
  },
  methods: {
    goPay() {
      this.$router.push({ path: '/shop/cartpay', query: { goodsId: this.form.id } })
    },
    queryGoodsOne(id) {
      var that = this
      this.$queryOne(
        'ProGoods',
        { id: id },
        [
          'id,proName,channel,shopSpecs,rentedSpecs,gallery,price,proDetail,proNotice,proFeature',
        ],
        function(res) {
          that.$fill(that.form, res['data'])
        }
      )
    },
    addCollect(id) {
      var that = this
      this.$submit(
        '/api/mycollect/addCollect',
        {
          myId: this.$store.getters.userId,
          goodsId: id,
        },
        function(res) {
          if (res['code'] === 1) {
            if (that.$store.getters.mycollect.indexOf(id) < 0) {
              that.$store.getters.mycollect.push(id)
            }
          }
        }
      )
    },
    cancelCollect(id) {
      var that = this
      this.$submit(
        '/api/mycollect/removeCollect',
        {
          myId: this.$store.getters.userId,
          goodsId: id,
        },
        function(res) {
          if (res['code'] === 1) {
            //that.$store.dispatch('mystatus', 0)
            // alert('OK')
            if (that.$store.getters.mycollect.indexOf(id) > -1) {
              let _index = that.$store.getters.mycollect.indexOf(id)
              that.$store.getters.mycollect.splice(_index, 1)
            }
          }
        }
      )
    },
    addCart(id) {
      var that = this
      this.$submit(
        '/api/mycart/addCart',
        {
          myId: this.$store.getters.userId,
          goodsId: id,
        },
        function(res) {
          if (res['code'] === 1) {
            //that.$store.dispatch('mystatus', 0)
            // alert('成功')
            if (that.$store.getters.mycart.indexOf(id) < 0) {
              that.$store.getters.mycart.push(id)
            }
          }
        }
      )
    },
    cancelCart(id) {
      var that = this
      this.$submit(
        '/api/mycart/removeCart',
        {
          myId: this.$store.getters.userId,
          goodsIds: [id],
        },
        function(res) {
          if (res['code'] === 1) {
            //that.$store.dispatch('mystatus', 0)
            // alert('成功')
            if (that.$store.getters.mycart.indexOf(id) > -1) {
              let _index = that.$store.getters.mycart.indexOf(id)
              that.$store.getters.mycart.splice(_index, 1)
            }
          }
        }
      )
    },
  },
}
</script>

<style>
.shopdetail {
  background: #fff;
  font-size: 1.4rem;
}
.shopdetail .txt {
  text-align: center;
  padding: 2.8rem 2rem 2.5rem;
}
.shopdetail .txt p {
  /* height: 2.5rem; */
  font-size: 1.8rem;
  color: #323232;
}
.shopdetail .txt .price {
  height: 2.8rem;
  font-size: 2rem;
  margin-top: 1.1rem;
  color: #15a892;
}
.shopdetail .contentdiv {
  padding: 0 0.8rem;
  margin: 1rem 0;
}
.shopdetail .contentdiv p {
  color: #323232;
}
.shopdetail .contentdiv section {
  min-width: 10rem;
  line-height: 3.6rem;
  float: left;
  color: #999;
  text-align: center;
  background: #eee;
  margin: 0.7rem 1.55rem 0.7rem 0;
  padding: 0 0.5rem;
}

.shopdetail .group {
  color: #fff !important;
  background-color: #15a892 !important;
}
.shopdetail .clear {
  clear: both;
  zoom: 1;
}

.shopdetail .clear:after {
  content: '';
  display: block;
  clear: both;
}
.shopdetail .txt {
  text-align: center;
  padding: 2.8rem 2rem 2.5rem;
}

.shopdetail .line {
  border-bottom: 1px solid #ccc;
}
.shopdetail .txt .txt1 {
  margin: 2.6px 0 1.3rem;
  line-height: 2rem;
  font-weight: 700;
  display: inline-block;
}
.shopdetail .txt .text1 {
  text-align: left !important;
  text-indent: 2em;
  line-height: 2.4rem;
  color: #323232;
  font-size: 1.4rem;
}
.shopdetail .txt .txt1:after,
.shopdetail .txt .txt1:before {
  content: '';
  display: inline-block;
  width: 2rem;
  height: 1px;
  border-top: 1px solid #008a3f;
  margin-right: 1.57rem;
  margin-bottom: 0.4rem;
}
.shopdetail .txt .txt1:after {
  margin-right: 0;
  margin-left: 1.57rem;
}

.shopdetail .txt .txt1:after,
.shopdetail .txt .txt1:before {
  content: '';
  display: inline-block;
  width: 2rem;
  height: 1px;
  border-top: 1px solid #008a3f;
  margin-right: 1.57rem;
  margin-bottom: 0.4rem;
}
.shopdetail .txt .txt1 {
  margin: 2.6px 0 1.3rem;
  line-height: 2rem;
  font-weight: 700;
  display: inline-block;
}

.shopdetail .txt {
  text-align: center;
  padding: 2.8rem 2rem 2.5rem;
}

.shopdetail .line {
  border-bottom: 1px solid #ccc;
}
.shopdetail .txt .txt1 {
  margin: 2.6px 0 1.3rem;
  line-height: 2rem;
  font-weight: 700;
  display: inline-block;
}

.shopdetail .txt .txt1:after,
.shopdetail .txt .txt1:before {
  content: '';
  display: inline-block;
  width: 2rem;
  height: 1px;
  border-top: 1px solid #008a3f;
  margin-right: 1.57rem;
  margin-bottom: 0.4rem;
}
.shopdetail .txt .txt1:after {
  margin-right: 0;
  margin-left: 1.57rem;
}

.shopdetail .txt .txt1:after,
.shopdetail .txt .txt1:before {
  content: '';
  display: inline-block;
  width: 2rem;
  height: 1px;
  border-top: 1px solid #008a3f;
  margin-right: 1.57rem;
  margin-bottom: 0.4rem;
}

.shopdetail .footdiv {
  background: #eee;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  display: flex;
  box-shadow: 0 -0.027rem 0.05333rem rgb(0 0 0 / 10%);
}
.shopdetail .footdiv .shop {
  width: 3.6rem;
  margin: 0 1.2rem 0 2rem;
  position: relative;
}
.shopdetail .footdiv .shop img {
  width: 2rem;
  height: 2rem;
  margin-top: 1.7rem;
  display: inline-block;
}
.shopdetail .footdiv .shop i {
  position: absolute;
  font-size: 1rem;
  top: 0.8rem;
  right: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
  line-height: 1.6rem;
  text-align: center;
  background: #15a892;
  color: #fff;
  border-radius: 50%;
}
.shopdetail .footdiv .add {
  width: 2.7rem;
  height: 2.7rem;
  margin-top: 1.25rem;
  margin-right: 2rem;
  display: inline-block;
}
.shopdetail .footdiv .addcart {
  background: #323232;
  color: #fff;
  width: 13rem;
  text-align: center;
}
.shopdetail .footdiv .goto {
  background: #15a892;
  color: #fff;
  width: 13rem;
  text-align: center;
}
.shopdetail .cart {
  width: 5.5rem;
  margin-right: 1rem;
  margin-top: 0.5rem;
  position: relative;
  line-height: 3.5rem;
  text-align: center;
}
.shopdetail .cart .icon {
  font-size: 2.5rem;
  color: #555;
}
.shopdetail .cart .nn {
  font-size: 1rem;
  color: #555;
  background: #dea767;
  position: absolute;
  top: 0;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50rem;
  line-height: 1.5rem;
  text-align: center;
  color: #fff;
}
.shopdetail .fav {
  width: 5rem;

  line-height: 5rem;
}
.shopdetail .fav .icon {
  font-size: 3rem;
  color: #555;
}
</style>
